/**
 * Strict email validation regex.
 * Ensures:
 * 1. Standard characters before @
 * 2. Domain name exists
 * 3. TLD (Top-Level Domain) is at least 2 characters long
 */
export const isValidEmail = (email) => {
  const strictEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return strictEmailRegex.test(email);
};